import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Stack } from "react-bootstrap";
import UserLogin from "../components/Login/UserLogin";

const LoginPage = () => {
    const [ isShown, setIsShown ] = useState(false);
    const navigate = useNavigate();
    
    const adminPage = () => {
        navigate("/Admin");
    };

    const userPage = () => {
        setIsShown(<UserLogin />);
    }

    return (
        <>
            <div style={{
                backgroundColor: '#00B1FF',
                backgroundImage: 'url(https://cdn.deelfietsnederland.nl/assets/dashboard/login_background.jpg)',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: '50%',
                height: '100vh'
            }}>
                <Container style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '15%'
                }}>
                    <Stack direction="horizontal" gap={3} >
                        {
                        // () => loginWithRedirect()
                        }
                        <Button onClick={adminPage}>
                            Admin
                        </Button>
                        <Button onClick={userPage} className="mt-25">
                            Tenant
                        </Button>
                    </Stack>
                </Container>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '70%'
                }}>
                    <Container>
                        {isShown}
                    </Container>
                    
                </div>
            </div>
        </>
    )
}

export default LoginPage;